
    // this file was auto generated by python script
    import Twitter from './Twitter';
    export default Twitter;
    